export default "__VITE_ASSET__X7PXwh5r__"